import { render, staticRenderFns } from "./AddProductPrice.vue?vue&type=template&id=29917b2b&"
import script from "./AddProductPrice.vue?vue&type=script&lang=js&"
export * from "./AddProductPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports